import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

// PrimeNG
import { SelectModule } from 'primeng/select';

// Composants
import { SelectBaseComponent } from '../abstract/select-base.component';

// Modèles
import { Country } from 'src/app/@shared/models/core/country.model';

// Utils
import { Sorter } from 'src/app/@shared/utilities/models/sorter';

@Component({
    selector: 'app-country-select',
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
    ],
    templateUrl: './country-select.component.html',
    styleUrls: ['./country-select.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CountrySelectComponent),
        multi: true,
    }],
})
export class CountrySelectComponent extends SelectBaseComponent<Country> {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    @Input() public placeholder: string = 'Pays';

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override _loadOptions(): void {
        this.countryService.getList$({
            selects: ['alpha2', 'flag', 'name'],
            sorters: [new Sorter({ property: 'name' })],
        }).subscribe(items => {
            this.options = items;
        });
    }
}
